import _extends from '@babel/runtime/helpers/extends';
import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import _toConsumableArray from '@babel/runtime/helpers/toConsumableArray';
import _defineProperty from '@babel/runtime/helpers/defineProperty';
import * as React from 'react';
import { List } from '../List/List.js';
import { RecursiveListItem } from './RecursiveListItem.js';

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

var returnProperlyFilteredList = function returnProperlyFilteredList(dataList, searchString, disabled) {
  var tempList = dataList.filter(function (item) {
    return !searchString || item.label.toLowerCase().includes(searchString);
  });
  var firstTabItem = tempList[0];
  var properlyTabFocusedList = tempList.map(function (item) {
    var newItem = _objectSpread({}, item);

    if (firstTabItem) {
      newItem.tabFocus = newItem.id === firstTabItem.id && !disabled;
    }

    return newItem;
  });
  return _toConsumableArray(properlyTabFocusedList);
};

var styles = {
  listRoot: {
    '& > li': {
      padding: 0
    },
    paddingBottom: 2
  }
};

var RecursiveListBase = function RecursiveListBase(_ref) {
  var dataList = _ref.dataList,
      searchString = _ref.searchString,
      clickHandler = _ref.clickHandler,
      expandChildClickHandler = _ref.expandChildClickHandler,
      disabled = _ref.disabled,
      isSelectedList = _ref.isSelectedList,
      forceShowRecursion = _ref.forceShowRecursion,
      parentSelectable = _ref.parentSelectable,
      doubleClickHandler = _ref.doubleClickHandler,
      toggleCascadeHandler = _ref.toggleCascadeHandler,
      toolTipExpand = _ref.toolTipExpand,
      toolTipCollapse = _ref.toolTipCollapse,
      toolTipCannotRemove = _ref.toolTipCannotRemove,
      toolTipRemove = _ref.toolTipRemove,
      inputRef = _ref.inputRef,
      textCascade = _ref.textCascade,
      sx = _ref.sx;

  var _React$useState = React.useState(_toConsumableArray(dataList)),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      filteredDataList = _React$useState2[0],
      setFilteredDataList = _React$useState2[1];

  var listRoot = styles.listRoot;
  React.useEffect(function () {
    setFilteredDataList(_toConsumableArray(returnProperlyFilteredList(dataList, searchString || '', disabled || false)));
  }, [dataList, searchString, disabled]);
  return /*#__PURE__*/React.createElement(List, {
    dense: true,
    component: "nav",
    role: "list",
    sx: [listRoot, sx],
    ref: inputRef
  }, filteredDataList.map(function (dataListItem) {
    return /*#__PURE__*/React.createElement(RecursiveListItem, _extends({
      id: dataListItem.id,
      selected: dataListItem.selected,
      expandable: dataListItem.expandable,
      dataListItem: dataListItem
    }, dataListItem.tabFocus && {
      tabFocus: true
    }, {
      clickHandler: clickHandler,
      doubleClickHandler: doubleClickHandler,
      expandChildClickHandler: expandChildClickHandler,
      key: dataListItem.id,
      isSelectedList: isSelectedList,
      forceShowRecursion: forceShowRecursion,
      label: dataListItem.label,
      searchString: searchString,
      showCascade: dataListItem.showCascade,
      showInnerChildren: false,
      showChildren: dataListItem.showChildren,
      parentSelectable: parentSelectable,
      toggleCascadeHandler: toggleCascadeHandler,
      toolTipExpand: toolTipExpand,
      toolTipCollapse: toolTipCollapse,
      toolTipCannotRemove: toolTipCannotRemove,
      toolTipRemove: toolTipRemove,
      textCascade: textCascade
    }));
  }));
};

RecursiveListBase.defaultProps = {
  isLoading: false
};
var RecursiveList = /*#__PURE__*/React.memo(RecursiveListBase);
export { RecursiveList };